import { message } from 'antd';

export type ReconnectHandlers = {
  isSlackUpgrading: boolean;
  setLegacyIntegrations: (integrations: any) => void;
  setJustUpgradedSlack: (justUpgradedSlack: boolean) => void;
  setIsSlackUpgrading: (isSlackUpgrading: boolean) => void;
};

export const handleReconnect = ({
  organizationId,
  legacyIntegrations,
  integration,
  ...handlers
}: ReconnectHandlers & {
  organizationId: string | undefined;
  legacyIntegrations: any;
  integration: string | null;
}): (() => Promise<void>) => {
  const integrationBaseUrl = `/organizations/${organizationId}/integrations`;
  const {
    setLegacyIntegrations,
    setJustUpgradedSlack,
    setIsSlackUpgrading
  } = handlers;

  const handleSlackReconnect = async () => {
    if (!organizationId) return message.error('Organization ID not found.');
    setIsSlackUpgrading(true);
    const token = (document.querySelector('meta[name="csrf-token"]') as any)
      ?.content;
    try {
      const response = await fetch(
        `${integrationBaseUrl}/destroy_all_of_type?integration_type=Integrations::SlackLegacy`,
        { method: 'DELETE', headers: { 'X-CSRF-Token': token } }
      );
      if (!response.ok)
        return message.error('Failed to disconnect legacy Slack integration.');
      const newLegacyIntegrations = { ...legacyIntegrations };
      if (newLegacyIntegrations.slacklegacy) {
        newLegacyIntegrations.slacklegacy.enabled = false;
      }
      setLegacyIntegrations(newLegacyIntegrations);
      setJustUpgradedSlack(true);
    } catch (error) {
      console.error(error);
      message.error('An error occurred while disconnecting.');
    } finally {
      setIsSlackUpgrading(false);
    }
  };

  return async () => {
    if (integration === 'slack') {
      handleSlackReconnect();
      return;
    }
  };
};
